define('shared/user',[
	"jquery",
	"shared/browser-detect"
	], 
	function ($, BrowserDetect) {
	/**
	 * This is helper class to provide about user's settings
	 */
	var User = function User(){}

	/**
	 * Get the permission status for the currently logged in user
	 * @param  {String}  permissionName   The name of perissmion
	 * @return {Boolean}
	 */
	User.prototype.hasPermission = function(permissionName) {
		try {
			if(!window.appData.user)
				return false;
			return window.appData.user.data.permissions[permissionName] === "allowed" || window.appData.user.data.permissions[permissionName] == 1;
		} catch(e) {
			return false;
		}
	}

	User.prototype.getProperty = function(prop) {
		return window.appData.user.data[prop];
	}

	/**
	 * Get the preference status for the currently logged in user
	 * @param  {String}  preferenceName   The name of preference
	 * @return {Boolean}
	 */
	User.prototype.getPreference = function(preferenceName) {
		try {
			return window.appData.user.data.preferences[preferenceName] === 1;
		} catch(e) {
			return false;
		}
	}

	/**
	 * Get the guid of the user
	 * @return {String}   The user guid
	 */
	User.prototype.getGUID = function() {
		try {
			return window.appData.user.data.guid;
		} catch(e) {
			return null;
		}
	}

	/**
	 * Get the sqs code associated with the user
	 * @return {String}   The user sqs code
	 */
	 User.prototype.getSQSCode = function() {
		try {
			return window.appData.user.data.sqs_code;
		} catch(e) {
			return null;
		}
	}

	/**
	 * Get the unsubscribed status of the user
	 * @author Dale Kelly
	 * @dateCreated 01/19/2021
	 * @return {String} the user unsubscribed status
	 */
	User.prototype.isUnsubscribed = function() {
		try {
			return window.appData.user.data.unsubscribed ? 'YES' : 'NO';
		} catch(e) {
			return null;
		}
	}

	/**
	 * Verify whether the user is from a country on the GDPR list
	 * @author Dale Kelly
	 * @dateCreated 06/01/2021
	 * @return {String} the user GDPR country status
	 */
	 User.prototype.isFromGDPRCountry = function() {
		try {
			return window.appData.user.data.from_gdpr_country ? 'YES' : 'NO';
		} catch(e) {
			return null;
		}
	}

	/**
	 * Get the country of the user
	 * @author Dale Kelly
	 * @dateCreated 01/19/2021
	 * @return {String} the user country
	 */
	User.prototype.getCountry = function() {
		try {
			return window.appData.user.data.country;
		} catch(e) {
			return null;
		}
	}
	
	/**
	 * Get the state of the user (for United States users)
	 * @author Dale Kelly
	 * @dateCreated 01/19/2021
	 * @return {String} the user's state
	 */
	User.prototype.getState = function() {
		try {
			return window.appData.user.data.state;
		} catch(e) {
			return null;
		}
	}

	/**
	 * Get the subscription status of the user
	 * @author Dale Kelly
	 * @dateCreated 01/19/2021
	 * @return {String} the user subscription status
	 */
	 User.prototype.getSubscriptionStatus = function() {
		try {
			return window.appData.user.data.type_history[0].details.subscription_status;
		} catch(e) {
			return null;
		}
	}

	/**
	 * Get the name of the user's subscription plan
	 * @author Dale Kelly
	 * @dateCreated 01/19/2021
	 * @param {String} currentPlan	the user's active subscription plan
	 * @return {String} the user's subscription plan name
	 */
	 User.prototype.getSubscriptionPlanName = function(currentPlan) {
		var subscriptionPlanNames = {
			"classroom-50-monthly": "Classroom Lite Monthly",
			"classroom-150-monthly": "Classroom Plus Monthly",
			"classroom-50-yearly": "Classroom Lite Yearly",
			"classroom-150-yearly": "Classroom Plus Yearly",
		};
		
		try {
			return subscriptionPlanNames[currentPlan];
		} catch(e) {
			return null;
		}
	}
	
	/**
	 * Get the previous type of the user
	 * @author Dale Kelly
	 * @dateCreated 01/19/2021
	 * @return {String} the user's previous type
	 */
	 User.prototype.getPrevUserType = function() {
		try {
			return window.appData.user.data.type_history[0].prev_user_type;
		} catch(e) {
			return null;
		}
	}

	/**
	 * Get the type of the user
	 * @return {String}   The user type
	 */
	User.prototype.getUserType = function() {
		try {
			return window.appData.user.data.type;
		} catch(e) {
			return false;
		}
	}

	/**
	 * Get the title of the user
	 * @return {String}   The user title
	 */
	User.prototype.getUserTitle = function() {
		try {
			return window.appData.user.data.title;
		} catch(e) {
			return false;
		}
	}

	/**
	 * Check if User has Password
	 */
	User.prototype.hasPassword = function() {
		try {
			return window.appData.user.data.has_password;
		} catch(e) {
			return false;
		}
	}

	/**
	 * Verify the user is Tenant who is created from Buncee
	 * @return {Boolean}
	 */
	User.prototype.isTenant = function() {
		try {
			return window.appData.user.data.source == "tenant" || window.appData.user.data.source == "csvimport";
		} catch(e) {
			return false;
		}
	}

	User.prototype.getSetting = function(settingName) {
		try {
			var settingNames = settingName.split('.');
			var setting = window.appData.user.data.settings;
			settingNames.forEach(function(settingName) {
				setting = setting[settingName];
			});
			return setting;
		} catch(e) {
			return null;
		}
	}

	User.prototype.isGenericFree = function() {
		return this.getUserType() === "generic-free";
	}

	User.prototype.isPremium = function() {
		return this.getUserType() === "generic-premium";
	}

	User.prototype.isTeacher = function() {
		return this.getUserType() === "teacher";
	}

	User.prototype.isStudent = function() {
		return this.getUserType() === "student";
	}

	User.prototype.isStudentStrict = function() {
		return this.getUserType() === "student"  || this.getUserTitle() === "student" ;
	}

	/**
	 * Detects whether the users has logged in before
	 * @return {boolean} true if the user has no previous logins, false otherwise
	 */
	User.prototype.isFirstLogin = function() {
		try {
			return window.appData.user.first_login || false;
		} catch(e) {
			return false;
		}
	}

	/**
	 * Get the email address of the user
	 * @return {String}  The email address of the user
	 */
	User.prototype.getEmail = function() {
		try {
			return window.appData.user.data.email;
		} catch(e) {
			return false;
		}
	}

	User.prototype.getAccessToken = function() {
		return window.appData.user.access_token;
	}

	User.prototype.isSimplePasswordEnabled = function() {
		return window.appData.user.data.supports_image_set_auth;
	}

	User.prototype.hasMatchedClient = function() {
		return (typeof window.appData.user.matchedClient !== "undefined");
	}

	User.prototype.getMatchedClient = function() {
		return window.appData.user.matchedClient || {};
	}

	/**
	 * Compile user data to send to GA
	 * @author Haley He
	 * @dataCreated 10/28/19
	 * @return {object} data to send to GA
	 */
	User.prototype.getGAUserInfo = function() {
		if (!window.appData.user)
			return {};
		else {
			return {
				guid: this.getGUID(),
				type: this.getUserType(),
				bsd: window.appData.client.name,
				device_type: BrowserDetect.getDeviceType()
			}
		}
	}

	/**
	 * Get the list of the user's schoools
	 * @authoer Haley He
	 * @date 4/30/21
	 * @returns Array
	 */
	User.prototype.getSchools = function() {
		try {
			return window.appData.user.data.schools;
		} catch(e) {
			return [];
		}
	}

	/**
	 * Checks if user is a pebblego create user
	 * @author Richard Lee
	 * @dateCreated 5/30/25
	 * @returns {boolean} checks if user's sync strategy is clever / classlink or has a sqs code
	 */

	User.prototype.isPgoUser = function() {
		return (window.appData.user.data.sqs_code || window.appData.user.data.client.sync_strategy === "clever" || window.appData.user.data.client.sync_strategy === "classlink");
	}

	return new User();
});
